import styled from "styled-components"
import { FormGroup } from "client/components"

const settingBorderRadius = "5px"

export const SettingList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;
`
export const Setting = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 8px 12px;
    justify-content: space-between;
    border: 1px solid ${(props) => props.theme.mailSettingsBorderColor};
    border-top: none;
    background: none;
    transition: ${(props) => props.theme.defaultTransition};

    &:first-child {
        border-top: 1px solid ${(props) => props.theme.mailSettingsBorderColor};
        border-top-left-radius: ${settingBorderRadius};
        border-top-right-radius: ${settingBorderRadius};
    }

    &:last-child {
        border-bottom-left-radius: ${settingBorderRadius};
        border-bottom-right-radius: ${settingBorderRadius};
    }

    &:hover {
        background: ${(props) => props.theme.mailSettingsHoverBackground};
    }
`
export const SettingValue = styled.div`
    color: ${(props) => props.theme.mailSettingsValueColor};
`
export const TemplateWrapper = styled.div`
    width: 100%;
    padding: 15px;

    ${FormGroup} {
        margin-bottom: 8px;
    }
`
